import { Type } from "class-transformer"
import { ArrayNotEmpty, IsArray, ValidateNested } from "class-validator"
import type { HttpDto } from "~/http/http.models"
import { Region } from "../region.model"

export class RegionsDto implements HttpDto<Region[]> {
  @Type(() => Region)
  @IsArray()
  @ArrayNotEmpty()
  @ValidateNested({ each: true })
  declare readonly data: Region[]
}
